import { connect } from 'react-redux';
import ScenarioModalComponent
  from './../Components/ScenarioModalComponent';
import {
  getScenariosByDispatcherId,
  getModalInfoByOwner,
  getModalVisibility
} from './../reducers';
import { metricsPage as metricPageSelectors } from '../selectors';
import { modal as modalActions } from './../actions';
import { modals } from './../helpers';

export const mapStateToProps = (state) => {
  const modalInfo = getModalInfoByOwner(state, modals.owners.scenarioStatus);
  const props = {
    title: 'Scenario Statuses',
    isVisible: getModalVisibility(state, modals.owners.scenarioStatus),
    scenarios: (getScenariosByDispatcherId(state, modalInfo.dispatcherId) ||
    []).map(scenario => {
      const status = metricPageSelectors
        .getAnalyzedMetricRunnerStatus(state, scenario.runner)
        .status;
      return { ...scenario, status: status };
    }),
    inProgressOnly: modalInfo.inProgressOnly
  };

  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    setInProgressOnly: (checked) =>
      dispatch(modalActions.setScenarioModalInProgressOnly(checked)),
    onHide: () => dispatch(modalActions.showScenarioModal(false))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScenarioModalComponent);


// WEBPACK FOOTER //
// src/Containers/ScenarioModalContainer.jsx